module.exports = __webpack_public_path__ + "static/media/6g_website_logo_Platinum_mtr.f5bcc67d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6g_website_logo_Platinum_mtr.jpg
// module id = 102
// module chunks = 0